import React, { useEffect, useRef, useState } from "react";
import type { PDFDocumentProxy } from "pdfjs-dist";

import { drawPage } from "./pdfPages";

/** One page of the PDF, drawn when it scrolls into view. */
const SlidePage = ({ doc, page, width }: { doc?: PDFDocumentProxy; page?: number; width: number }) => {
  const canvas = useRef<HTMLCanvasElement>(null);
  const [visible, setVisible] = useState(typeof IntersectionObserver === "undefined");

  useEffect(() => {
    const node = canvas.current;
    if (visible || !node) return undefined;
    const observer = new IntersectionObserver((seen) => {
      if (seen.some((entry) => entry.isIntersecting)) setVisible(true);
    }, { rootMargin: "200px" });
    observer.observe(node);
    return () => observer.disconnect();
  }, [visible]);

  useEffect(() => {
    if (!doc || !page || !visible || !canvas.current) return undefined;
    const draw = drawPage(doc, page, canvas.current, width);
    return draw.cancel;
  }, [doc, page, width, visible]);

  if (!page) return null;
  // Sized to the slide before it draws, so nothing below it moves when it does.
  return (
    <canvas ref={canvas}
            style={{ width, aspectRatio: "var(--slide-aspect)", background: "#e8e8e8" }} />
  );
};

export default SlidePage;
